import React, { useEffect, useState } from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import { CheckCircleFill } from "react-bootstrap-icons";
import { Helmet } from "react-helmet";

import { Loading, Toggle } from "./utils";

const StreamChecker = (props) => {
  const defaultSettings = {
    defaultGame: "LoL",
    defaultItems: "8",
    defaultGames: ["LoL", "TFT", "LoR", "VALORANT", "WR"],
    defaultSites: ["Twitch", "Mildom", "OPENREC"],
    displayGames: ["LoL", "TFT", "LoR", "VALORANT", "WR"],
    displaySites: ["Twitch", "Mildom", "OPENREC"],
  };

  // localStorageに設定があればdefaultSettingsを上書きする
  const loadedSettings = JSON.parse(
    localStorage.getItem("StreamCheckerSettings")
  );

  const initSettings = Object.assign(defaultSettings, loadedSettings);


  // niconico終了の対応
  initSettings.defaultGames.some((v, i) => {
    if (v === "niconico") initSettings.defaultGames.splice(i, 1)
    return false
  });
  initSettings.displaySites.some((v, i) => {
    if (v === "niconico") initSettings.displaySites.splice(i, 1)
    return false
  });


  const [settings, setSettings] = useState(initSettings);
  const [game, setGame] = useState(initSettings.defaultGame);
  const [data, setData] = useState({});

  const onClickGame = (e) => selectGame(e.target.textContent);

  const selectGame = (selectedGame) => {
    setGame(selectedGame);
    document.querySelectorAll("#games .select-game").forEach((a) => {
      if (selectedGame === a.textContent) {
        a.className = "select-game nav-link stream-nav-link active";
      } else {
        a.className = "select-game nav-link text-primary stream-nav-link";
      }
    });
  };

  const updateSettings = (params) => {
    localStorage.setItem("StreamCheckerSettings", JSON.stringify(params));
    setSettings(params);
    selectGame(params.defaultGame);
  };

  useEffect(() => {
    (async () => {
      const res = await fetch(
        "https://script.google.com/macros/s/" +
          process.env.REACT_APP_SHEET_ID +
          "/exec?q=streamchecker"
      );
      const json = await res.json();
      setData(json);
      selectGame(game);
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="common-bg-grey">
      <Helmet
        title="LoL Stream Checker"
        meta={[
          { name: "twitter:card", content: "summary" },
          {
            property: "og:url",
            content:
              "https://sightstones.netlify.app" + props.location.pathname,
          },
          { property: "og:title", content: "LoL Stream Checker" },
          {
            property: "og:image",
            content: "https://sightstones.netlify.app/img/ogp.png",
          },
        ]}
      >
        <link rel="manifest" href="/manifest-streamchecker.json" />
      </Helmet>
      <Container className="stream bg-white">
        <header>
          <p className="text-right">Last Update: {data.updated}</p>
          <h1 className="my-5 h2 stream-title text-center">
            LoL Stream Checker
          </h1>
        </header>
        <Navi onClickGame={onClickGame} displayGames={settings.displayGames} />
        <Row>
          {!data.games ? (
            <Loading />
          ) : (
            <>
              {settings.displaySites.map((site) => (
                <StreamList
                  site={site}
                  key={site}
                  streams={data.games[game.toLowerCase()][site].list.slice(
                    0,
                    settings.defaultItems === "ALL"
                      ? data.games[game.toLowerCase()][site].list.length
                      : parseInt(settings.defaultItems)
                  )}
                  link={data.games[game.toLowerCase()][site].link}
                  all={data.games[game.toLowerCase()][site].list.length}
                />
              ))}
            </>
          )}
        </Row>
        {!data.games ? (
          ""
        ) : (
        <div className="text-center">
          <Toggle>
            <footer>
              <Setting settings={settings} updateSettings={updateSettings} />
            </footer>
          </Toggle>
        </div>
        )}
      </Container>
      <script
        dangerouslySetInnerHTML={{
          __html: window.addEventListener("load", function () {
            if ("serviceWorker" in navigator) {
              navigator.serviceWorker
                .register("/serviceWorker.js")
                .then(function () {
                  console.log("serviceWorker registed.");
                })
                .catch(function (error) {
                  console.warn("serviceWorker error.", error);
                });
            }
          }),
        }}
      />
    </div>
  );
};

const Navi = (props) => {
  return (
    <ul id="games" className="nav nav-pills nav-fill mb-5 bg-light">
      {props.displayGames.map((game) => (
        <li className="nav-item" key={game}>
          <span
            className="select-game nav-link stream-nav-link text-primary"
            onClick={props.onClickGame}
          >
            {game}
          </span>
        </li>
      ))}
    </ul>
  );
};

const StreamList = (props) => {
  return (
    <Col md={6} sm={12} key={props.site} className="mb-4">
      <h2 className="stream-caption">
        <span>{props.site}</span>
      </h2>
      <Table>
        <tbody>
          {props.streams.map((stream) => (
            <tr key={stream.link}>
              <td className="align-middle">
                <a href={stream.link} target="_blank" rel="noopener noreferrer">
                  <img
                    width={80}
                    height={45}
                    src={stream.thumbnail}
                    alt={stream.title}
                  />
                </a>
              </td>
              <td>
                <a href={stream.link} target="_blank" rel="noopener noreferrer">
                  <h5 className="stream-item-title">{stream.title}</h5>
                </a>
                {stream.vip ? (
                  <CheckCircleFill
                    className="mr-2 text-info"
                    style={{ verticalAlign: "text-top" }}
                  />
                ) : null}
                <span>{stream.streamer}</span>
              </td>
              <td className="stream-item-view" valign="middle">
                {stream.view}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <p className="text-center">
        <a href={props.link} target="_blank" rel="noopener noreferrer">
          All: {props.all === 100 ? "over 100" : props.all} streams.
        </a>
      </p>
    </Col>
  );
};

const Setting = (props) => {
  const save = () => {
    const defaultGame = document.defaultGame.select.value;
    const defaultItems = document.defaultItems.select.value;
    const displayGames = [];
    const displaySites = [];
    document.displayGames.games.forEach((game) =>
      game.checked ? displayGames.push(game.value) : false
    );
    document.displaySites.sites.forEach((site) =>
      site.checked ? displaySites.push(site.value) : false
    );
    props.updateSettings({
      defaultGame: defaultGame,
      defaultItems: defaultItems,
      defaultGames: props.settings.defaultGames,
      defaultSites: props.settings.defaultSites,
      displayGames: displayGames,
      displaySites: displaySites,
    });
  };

  const defaultGamesOptions = props.settings.defaultGames.map((game) => (
    <option value={game} key={game}>
      {game}
    </option>
  ));

  const defaultItemsOptions = ["5", "8", "10", "20", "ALL"].map((s) => (
    <option value={s} key={s}>
      {s}
    </option>
  ));

  const displayGamesCheckboxes = props.settings.defaultGames.map((game) => (
    <div className="form-check mb-1 ml-1" key={game}>
      <input
        className="form-check-input"
        type="checkbox"
        name="games"
        value={game}
        id={`game-${game}`}
        defaultChecked={
          props.settings.displayGames.indexOf(game) >= 0 ? true : false
        }
        style={{ transform: "scale(1.3)", marginTop: "0.4rem" }}
      />
      <label className="form-check-label ml-1" htmlFor={`game-${game}`}>
        {game}
      </label>
    </div>
  ));

  const displaySitesCheckboxes = props.settings.defaultSites.map((site) => (
    <div className="form-check mb-1 ml-1" key={site}>
      <input
        className="form-check-input"
        type="checkbox"
        name="sites"
        value={site}
        id={`site-${site}`}
        defaultChecked={
          props.settings.displaySites.indexOf(site) >= 0 ? true : false
        }
        style={{ transform: "scale(1.3)" }}
      />
      <label className="form-check-label ml-1" htmlFor={`site-${site}`}>
        {site}
      </label>
    </div>
  ));

  return (
    <Row className="bg-light text-left pt-5">
      <Col md={3} sm={12} className="px-4 pb-4">
        <h5 className="mb-4">Default Game</h5>
        <form name="defaultGame" className="form-group">
          <select
            className="form-control"
            name="select"
            onChange={save}
            defaultValue={props.settings.defaultGame}
          >
            {defaultGamesOptions}
          </select>
        </form>
      </Col>
      <Col md={3} sm={12} className="px-4 pb-4">
        <h5 className="mb-4">Items</h5>
        <form name="defaultItems" className="form-group">
          <select
            className="form-control"
            name="select"
            onChange={save}
            defaultValue={props.settings.defaultItems}
          >
            {defaultItemsOptions}
          </select>
        </form>
      </Col>
      <Col md={3} sm={12} className="px-4 pb-4">
        <h5 className="mb-4">Games</h5>
        <form name="displayGames" onChange={save}>
          {displayGamesCheckboxes}
        </form>
      </Col>
      <Col md={3} sm={12} className="px-4 pb-4">
        <h5 className="mb-4">Sites</h5>
        <form name="displaySites" onChange={save}>
          {displaySitesCheckboxes}
        </form>
      </Col>
    </Row>
  );
};

export default StreamChecker;
